import React, { useEffect, useState, useRef } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { deleteAttachments, getAttachmentsAsync } from './AttachmentSlice';
import './styles.css'
import { Button, Modal, Spinner } from 'react-bootstrap';
import { ShowToast } from '../../common/Toastr';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import moment from 'moment';
import { toAbsoluteUrl } from '../../_metronic/helpers';
import { useTranslation } from 'react-i18next';
import CanvasLoader from '../../common/CanvasLoader';
import Fancybox from '../../common/fancybox';
import { Fancybox as NativeFancybox } from '@fancyapps/ui';
import { display } from 'html2canvas/dist/types/css/property-descriptors/display';
import { formatDateWithDateAndMonthName, getValueFromResource } from '../../common/timeLiveFunction';


// import { saveAs } from 'file-saver';

const GetAttachments = (props: any) => {
    const { Id, AccountAttachmentTypeId, IsShowEmployeeInformation,isDisabled = false } = props;
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [rehit, setRehit] = useState(false);
    const [loading, setLoading] = useState(false)
    const [errorImages, setErrorImages] = useState<any>([]);
    const [imageToShow, setImageToShow] = useState('');
    const [extension, setExtension] = useState('');
    const dispatch = useAppDispatch();
    const { attachmentList, employeeInformation, isReload, isCanvasLoader } = useAppSelector(state => state.attachment);
    const { decimalPlaces, cultureInfoName, employeeName: EmpName } = useAppSelector((state) => state.globalState);
    const dates: any = [];
    // const downloadRef = useRef<any>(null);

    useEffect(() => {
        dispatch(getAttachmentsAsync({ Id: Id, ControllerName: getAttachmentType(AccountAttachmentTypeId) }));
    }, [dispatch])

    useEffect(() => {
        if (rehit || isReload) {
            dispatch(getAttachmentsAsync({ Id: Id, ControllerName: getAttachmentType(AccountAttachmentTypeId) }));
        }
    }, [rehit, isReload])

    const getAttachmentType = (AccountAttachmentTypeId: any) => {
        let controllerName = "";
        if (AccountAttachmentTypeId === 1) { controllerName = "ExpenseSheets" }
        else if (AccountAttachmentTypeId === 2) { controllerName = "Timesheets" }
        else if (AccountAttachmentTypeId === 3) { controllerName = "TimeOffs" }
        else if (AccountAttachmentTypeId === 4) { controllerName = "Projects" }
        else if (AccountAttachmentTypeId === 5) { controllerName = "Tasks" }
        return controllerName;
    }

    const handleOpenModal = (imgUrl: string, index: number) => {
        setShow(true);
        let ext = getFileExtension(imgUrl);
        setExtension(ext);
        if (ext === "xls" || ext === "xlsx" || ext === "doc" || ext === "docx") {
            const url = `https://docs.google.com/gview?url=${imgUrl}&embedded=true`;
            setImageToShow(url);
        }
        else {
            setImageToShow(imgUrl);
        }
    }

    function getFileExtension(filename: string) {
        return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
    }
    const handleClose = () => setShow(false);

    const handleDelete = (AccountAttachmentId: any, AttachmentLocalPath: any) => {
        // ShowSwalWithConfirmation("Are you sure you want to delete this attachment?", '').then(result => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "", 'Yes delete it!', 'custom-swal-container').then(result => {
            if (result) {
                dispatch(deleteAttachments({ AccountAttachmentId: AccountAttachmentId, AttachmentLocalPath: AttachmentLocalPath, ControllerName: getAttachmentType(AccountAttachmentTypeId) })).unwrap().then((result: any) => {
                    setLoading(true);
                    ShowToast('Success', 'File Deleted Successfully!', "success", "toast-top-right");
                    setRehit(!rehit);
                    setLoading(false);

                }).catch((err: any) => {
                    setLoading(false);
                    ShowToast('Error', 'Something went wrong!', "error", "toast-top-right");
                })
            }
            else {
                setLoading(false);
            }
        }).catch(err => {
        })
    }

    const handleImageError = (index: number) => {
        setErrorImages((prevErrorImages: any) => [...prevErrorImages, index]);
    };

    const downAsSavePackageUrl = async (url: string, name: string) => {
        // //Rameez Work
        // const link = downloadRef.current;
        // link.href = url;
        // link.download = name;
        // link.click();
        // // const imageblob = await fetch(url).then((response) => response.arrayBuffer()).then((buffer) => new Blob([buffer], {type: "image/png"}));
        // // const anchor = document.createElement('a');
        // // anchor.href = URL.createObjectURL(imageblob);
        // // anchor.download = name;
        // // document.body.appendChild(anchor);
        // // anchor.click();
        // // document.body.removeChild(anchor);

        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = name;
        anchor.target = '_blank';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }

    const CurrentCultureDateFormatInUpperCase = 'DD/MM/YYYY';
    const noOfDaysAgo = (CreatedOn: any) => {
       // var createdDate = parseDate(moment(CreatedOn).format(CurrentCultureDateFormatInUpperCase)); //moment(CreatedOn).format("MM-DD-YYYY");
        // var currentDate = moment().format("MM-DD-YYYY");

        // var a = moment(createdDate, "MM-DD-YYYY");
        // var b = moment(currentDate, "MM-DD-YYYY");
        // return b.diff(a, 'days');
        const createdDate = moment(CreatedOn);
        const currentDate = moment();
        return currentDate.diff(createdDate, 'days');
    }

    const formats = ['MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD', 'MM-DD-YYYY']; // Add more formats as needed
    function parseAndFormatDate(dateString: string) {
        for (let format of formats) {
            const parsedDate = moment(dateString, format, true); // Use strict parsing mode
            if (parsedDate.isValid()) {
                return parsedDate.format('MMMM D');
            }
        }
        return 'Invalid date'; // If none of the formats matched
    }
    function parseDate(dateString: string) {
        for (let format of formats) {
            const parsedDate = moment(dateString, format, true); // Use strict parsing mode
            if (parsedDate.isValid()) {
                return parsedDate;
            }
        }
        return 'Invalid date'; // If none of the formats matched
    }
    const handleClick = (event : any) => {
        event.preventDefault();
        console.log('handle click');
        // You can also add any other logic here if needed
      };
    return (
        <>
            {IsShowEmployeeInformation && employeeInformation?.length > 0 ? (
                <div className="row col-md-12 col-sm-12 col-xs-12 " style={{ justifyContent: 'center', marginBottom: 12 }}>
                    <div className="col-md-3 col-sm-3 col-xs-12">
                        <div className="d-flex  mb-2">
                            <div className="symbol symbol-45px me-2">
                                <i className="ki-outline ki-user fs-2"></i>
                            </div>
                            <div className="d-flex align-items-center flex-wrap">
                                <div className="flex-grow-1 me-1">
                                    <span className="text-dark fw-bold d-block text-uppercase">
                                        {/* {t('Employee')} */}
                                        {getValueFromResource('Employee',dispatch, t)}
                                        </span>
                                    <a
                                        //className="text-gray-400 fs-9 fw-bold fw-semibold text-uppercase"
                                        style={{ color: '#7b8ba6', fontSize: 11 }}
                                    >{employeeInformation ? employeeInformation[0]?.EmployeeName : ""} </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 col-xs-12">
                        <div className="d-flex ">
                            <div className="symbol symbol-45px me-2">
                                <i className="bi bi-circle  fs-2"></i>
                            </div>
                            <div className="d-flex align-items-center flex-wrap">
                                <div className="flex-grow-1 me-1">
                                    <span className="text-dark fw-bold d-block text-uppercase">
                                        {/* {t('Type')} */}
                                        {getValueFromResource('Type',dispatch, t)}
                                        </span>
                                    <a
                                        //className="text-gray-400 fs-9 fw-semibold text-uppercase"
                                        style={{ color: '#7b8ba6', fontSize: 11 }}
                                    >{employeeInformation ? employeeInformation[0]?.AccountTimeOffType : ""}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 col-xs-12">
                        <div className="d-flex ">
                            <div className="symbol symbol-45px me-2">
                                {/* <i className="bi bi-calendar  fs-2"></i> */}
                                <i className="ki-outline ki-calendar text-gray fs-2 me-2 "></i>
                            </div>
                            <div className="d-flex align-items-center flex-wrap">
                                <div className="flex-grow-1 me-1">
                                    <span className="text-dark fw-bold d-block text-uppercase">
                                        {/* {t('Request Date')} */}
                                        {getValueFromResource('Request Date',dispatch, t)}
                                        </span>
                                    <a
                                        //className="text-gray-400 fs-9 fw-semibold text-uppercase"
                                        style={{ color: '#7b8ba6', fontSize: 11 }}
                                    >{employeeInformation ? (moment(employeeInformation[0]?.RequestSubmitDate).format(CurrentCultureDateFormatInUpperCase)) : ""}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 col-xs-12">
                        <div className="d-flex ">
                            <div className="symbol symbol-45px me-2">
                                <i className="bi bi-check  fs-2"></i>
                            </div>
                            <div className="d-flex align-items-center flex-wrap">
                                <div className="flex-grow-1 me-1">
                                    <span className="text-dark fw-bold d-block text-uppercase">
                                        {/* {t('Request Status')} */}
                                        {getValueFromResource('Request Status',dispatch, t)}
                                        </span>
                                    <a
                                        //className="text-gray-400 fs-9 fw-semibold text-uppercase"
                                        style={{ color: '#7b8ba6', fontSize: 11 }}
                                    >
                                        {employeeInformation ? employeeInformation[0]?.ApprovalStatus : ""}
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            ) : null
            }
            {
                <table className="gvtabletodt table  order-column" >
                    <thead>
                    </thead>
                    <tbody style={{ cursor: 'pointer' }}>
                        {isCanvasLoader ? <CanvasLoader /> : <>
                            {loading ? (
                                <div className="text-center">
                                    <Spinner style={{ height: '30px', width: '30px' }} animation="border" variant="primary" />
                                </div>
                            ) :
                                (
                                    attachmentList?.length <= 0 ? (
                                        <tr><td colSpan={0}><p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p></td></tr>
                                    ) : (
                                        attachmentList?.map((data: any, index: number) => {
                                            // const createdDate = moment(data.CreatedOn).format(CurrentCultureDateFormatInUpperCase);
                                            // const monthName = parseAndFormatDate(createdDate);
                                            // const currentMonthIndex = dates.indexOf(monthName);
                                            const monthName = formatDateWithDateAndMonthName(data.CreatedOn, cultureInfoName.toString());
                                            const currentMonthIndex = dates.indexOf(monthName);
                                            if (currentMonthIndex === -1) {
                                                dates.push(monthName);
                                            }
                                            return (
                                                <>
                                                    {currentMonthIndex === -1 && (
                                                        <tr key={`${monthName}-row`} style={{ backgroundColor: '#F3F3F3' }}>
                                                            <td colSpan={3}><span className='text-dark fw-bold d-block text-uppercase pl-2' 
                                                            style={{ paddingLeft: '7px' }}> {monthName}</span></td>
                                                        </tr>
                                                    )}
                                                    <tr key={data.AccountAttachmentId}>
                                                        <td style={{ width: "5%", paddingRight: 0, paddingLeft: 0 }}>
                                                            <Fancybox
                                                                options={{
                                                                    Toolbar: {
                                                                        display: {
                                                                            left: ["infobar"],
                                                                            middle: [],
                                                                            right: ["close"],
                                                                        },
                                                                    },
                                                                }}
                                                            >
                                                                {(data.AttachmentLocalPath.endsWith('.xls') || data.AttachmentLocalPath.endsWith('.docx') || data.AttachmentLocalPath.endsWith('.xlsx') || data.AttachmentLocalPath.endsWith('.doc')) ? (
                                                                    <div>
                                                                        {/* Preview Image Link */}
                                                                        <a data-fancybox={`iframe-${index}`} href={`#iframe-${index}`}   >
                                                                            <img
                                                                                src={toAbsoluteUrl('./media/images/defaultImageFile1.png')} // Placeholder image
                                                                                alt={`Document ${index + 1}`}
                                                                                style={{ width: '100px', height: '100px' }}
                                                                            />
                                                                        </a>

                                                                        {/* Hidden iframe container */}
                                                                        <div style={{ display: 'none' }} id={`iframe-${index}`}>
                                                                            <iframe
                                                                                src={`https://docs.google.com/gview?url=${data.NewConvertAttachmentLocal}&embedded=true`}
                                                                                width="100%"
                                                                                height="500"
                                                                                style={{ border: 'none' }}
                                                                                title={`Preview ${index + 1}`}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <a 
                                                                    data-fancybox="gallery" 
                                                                    //href={data.NewConvertAttachmentLocal}
                                                                    href={!isDisabled ? data.NewConvertAttachmentLocal : undefined} // Disable link if isDisabled is true
                                                                    onClick={(event) => {
                                                                        if (isDisabled) {
                                                                          event.preventDefault(); // Prevent default action if disabled
                                                                        }
                                                                      }}
                                                                      style={{ pointerEvents: isDisabled ? 'none' : 'auto'
                                                                        //, opacity: true ? 0.5 : 1 
                                                                    }} // Adjust styles based on disabled state
                                                                    >
                                                                        <img
                                                                            src={errorImages.includes(index) ? toAbsoluteUrl('./media/images/defaultImageFile1.png') : data.NewConvertAttachmentLocal}
                                                                            onError={() => handleImageError(index)}
                                                                            alt={`Image ${index + 1}`}
                                                                            style={{ width: '100px', height: '100px' }}
                                                                        />
                                                                    </a>
                                                                )}
                                                            </Fancybox>
                                                        </td>
                                                        {/* <td style={{ width: "5%", paddingRight: 0, paddingLeft: 0 }}>
                                                            <Fancybox
                                                                options={{
                                                                    Toolbar: {
                                                                        display: {
                                                                            left: ["infobar"],
                                                                            middle: [],
                                                                            right: ["close"], // Download ko nikaal diya, custom download link add karenge
                                                                        },
                                                                    },
                                                                }}
                                                            >
                                                                {data.AttachmentLocalPath.endsWith('.pdf') || data.AttachmentLocalPath.endsWith('.xls') || data.AttachmentLocalPath.endsWith('.docx') || data.AttachmentLocalPath.endsWith('.xlsx') ? (
                                                                    <div>
                                                                        <a data-fancybox="gallery" href={data.NewConvertAttachmentLocal}>
                                                                            <img
                                                                                src={toAbsoluteUrl('./media/images/defaultImageFile1.png')} // PDF icon ya koi placeholder image
                                                                                alt={`PDF ${index + 1}`}
                                                                                style={{ width: '100px', height: '100px' }}
                                                                            />
                                                                        </a>
                                                                        <a href={data.NewConvertAttachmentLocal} download={data.AttachmentLocalPath} style={{ marginLeft: '10px', display: 'block' }}>
                                                                        </a>
                                                                    </div>
                                                                ) : (
                                                                    <a data-fancybox="gallery"
                                                                        href={data.NewConvertAttachmentLocal}
                                                                        download
                                                                    >
                                                                        <img
                                                                            src={errorImages.includes(index) ? toAbsoluteUrl('./media/images/defaultImageFile1.png') : data.NewConvertAttachmentLocal}
                                                                            onError={() => handleImageError(index)}
                                                                            alt={`Image ${index + 1}`}
                                                                            style={{ width: '100px', height: '100px' }}
                                                                        />
                                                                    </a>
                                                                )}
                                                            </Fancybox>

                                                        </td> */}

                                                        <td>
                                                            <div className='d-flex flex-column '>
                                                                <span className='text-dark fw-bold d-block text-uppercase' >{data.AttachmentName}</span>
                                                                <span style={{ color: '#7b8ba6', fontSize: 11 }}>by {data.EmployeeName ?? EmpName} {noOfDaysAgo(data.CreatedOn)} days ago - {data.ImageSizeInKB} KB </span>

                                                            </div>
                                                        </td>
                                                        <td style={{ marginLeft: 'auto', width: '10%' }}>

                                                            <div className='d-flex align-items-center' style={{ borderRadius: '10px' }}>
                                                                <Fancybox
                                                                    options={{
                                                                        Toolbar: {
                                                                            display: {
                                                                                left: ["infobar"],
                                                                                middle: [],
                                                                                right: ["close"], // Customize the toolbar options as needed
                                                                            },
                                                                        },
                                                                    }}
                                                                >
                                                                    {/* Determine file type */}
                                                                    {/* {data.NewConvertAttachmentLocal.endsWith('.jpg') || data.NewConvertAttachmentLocal.endsWith('.jpeg') || data.NewConvertAttachmentLocal.endsWith('.png') || data.NewConvertAttachmentLocal.endsWith('.gif') ? ( */}
                                                                    {(data.AttachmentLocalPath.endsWith('.xls') || data.AttachmentLocalPath.endsWith('.docx') || data.AttachmentLocalPath.endsWith('.xlsx') || data.AttachmentLocalPath.endsWith('.doc')) ? (
                                                                        // If document
                                                                        // <div className='btn btn-sm btn-icon me-1' onClick={() => handleOpenModal(data.NewConvertAttachmentLocal, index)}>
                                                                        //     <i className='bi bi-file-earmark-text fs-3 iconColor'></i> {/* You can use a different icon for documents */}
                                                                        // </div>
                                                                        <>
                                                                            <div className='btn btn-sm btn-icon me-1' data-fancybox={`gallery-${index}`} data-src={`#iframe-${index}`}>
                                                                                <i className='bi bi-file-earmark-text fs-3 iconColor'></i> {/* Use appropriate icon */}
                                                                            </div>

                                                                            {/* Hidden iframe container */}
                                                                            <div style={{ display: 'none' }} id={`iframe-${index}`}>
                                                                                <iframe
                                                                                    src={`https://docs.google.com/gview?url=${data.NewConvertAttachmentLocal}&embedded=true`}
                                                                                    width="100%"
                                                                                    height="500"
                                                                                    style={{ border: 'none' }}
                                                                                    title={`Preview ${index + 1}`}
                                                                                />
                                                                            </div>
                                                                        </>

                                                                    ) : (
                                                                        // If image
                                                                        // <div className='btn btn-sm btn-icon me-1' onClick={() => handleOpenModal(data.NewConvertAttachmentLocal, index)}>
                                                                        //     <i className='bi bi-file-image fs-3 iconColor'></i>
                                                                        // </div>
                                                                        <a data-fancybox={`gallery-${index}`} 
                                                                        href={data.NewConvertAttachmentLocal}
                                                                        
                                                                      style={{display:isDisabled ? 'none':'block'}}
                                                                        >
                                                                            <div className='btn btn-sm btn-icon me-1'>
                                                                                <i className={`bi ${data.AttachmentLocalPath.endsWith('.pdf') ? 'bi-file-earmark-text' : 'bi-file-image'}  fs-3 iconColor`}></i> {/* Icon for image files */}
                                                                            </div>
                                                                        </a>


                                                                    )}
                                                                </Fancybox>
                                                                <div className='btn btn-sm btn-icon me-1' onClick={() => downAsSavePackageUrl(data.NewConvertAttachmentLocal, data.AttachmentName)}>
                                                                    <i className='bi bi-download fs-3 iconColor'></i>
                                                                </div>
                                                                <div className='btn btn-sm btn-icon me-1' onClick={() => handleDelete(
                                                                    AccountAttachmentTypeId === 4 ? data.AccountProjectAttachmentId :
                                                                        AccountAttachmentTypeId === 5 ? data.AccountProjectTaskAttachmentId :
                                                                            data.AccountAttachmentId,
                                                                    data.AttachmentLocalPath
                                                                )}>
                                                                    <i className='bi bi-trash fs-3 delete-menu-icon-color allign'></i>
                                                                </div>
                                                            </div>

                                                        </td>
                                                    </tr>
                                                </>
                                            )
                                        }))
                                )

                            }
                        </>
                        }
                    </tbody>
                </table>
            }
            {/* <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="custom-modal"
                size="lg"
            >
                <Modal.Header className='modal-header pb-2' style={{ padding: "10px" }}>
                    <h5>Preview</h5>
                </Modal.Header>
                <Modal.Body className="custom-modal-modal-body">
                    {extension === 'pdf' || extension === 'docx' || extension === 'xls' || extension === 'xlsx' ? (
                        <iframe
                            src={imageToShow}
                            width="100%"
                            height="500"
                        />
                    ) : (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif' ? (
                        <img src={imageToShow} className="custom-modal-modal-image" alt="image" />
                    ) : null
                    )}
                </Modal.Body>
                <Modal.Footer className="modal-footer" style={{ padding: "10px" }}>
                    <button
                        onClick={handleClose}
                        type="button"
                        className="btn btn-primary btn-sm me-2"
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal> */}
        </>
    )
}

export default GetAttachments



